<template>
<!-- 页头 -->
  <div class="top">
    <!-- 菜单栏 -->
    <div class="container vue_flex">
      <!-- logo图片 svg图片用背景图引用 -->
      <div class='vue_flex'>
        <i></i>
      </div>

      <!-- 菜单 -->
      <!-- :default-active="$route.path" router :绑定路由表 
        router：为true,是否使用 vue-router 的模式，启用该模式会在激活导航时以 index 作为 path 进行路由跳转
        text-color:菜单文字颜色 active-text-color:激活时的颜色  mode：横向菜单 -->
      <el-menu :default-active="$route.path" router mode="horizontal" background-color="transparent"
        text-color="white" active-text-color="white">
        <el-menu-item index="/">公司介绍</el-menu-item>
        <el-menu-item index="/pc/connect">联系我们</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>
// 去掉菜单栏的大下划线
.el-menu.el-menu--horizontal{
  border-bottom: none;
}
// 去掉每个tab的下划线
.el-menu--horizontal > .el-menu-item {
  border-bottom: none;
  text-decoration: none;
}
.el-menu--horizontal > .el-menu-item.is-active {
//   border-bottom: none;
//   text-decoration: none;
  font-weight: 600;
}

/* 变短的效果 */
// .el-menu--horizontal > .el-menu-item.is-active.shorten {
//   border-bottom-width: 20px; /* 仅变短底部边框 */
// }

.el-menu--horizontal>.el-menu-item {
  height: 72px;
  line-height: 72px;
}

/* 鼠标悬停时的背景颜色改为透明 */
.el-menu-item:hover {
  background-color: transparent !important;
}

.top{
  background-color: #2A4DE7;
  height: 72px;
  line-height: 72px;
  // border-bottom: 1px solid #CCCCCC;
  // margin-bottom: 12px;
  i{
    // width:123px;
    width:160px;
    height:48px;
    align-self:center;// 垂直居中
    background-image: url("../assets/feedying-logo.svg");
    background-repeat: no-repeat;// 背景图不平铺
    background-size:cover;// 全覆盖
    background-position: center; //指定元素背景图片的位置
  }
}
</style>